import request from '../utils/request';

/**
 * method POST 解锁 DELETE 强制解锁 GET 查询锁状态
 */
export async function lock(id, method, isLeave) {
  let content = null;
  if (method && method !== 'GET') {
    content = {
      method,
      body: {
        id
      }
    };
  }
  // 区分强制解锁和非强制解锁
  if (isLeave) {
    return request(`/api/compose/manage/lock/${id}?type=leave`, content);
  } else {
    return request(`/api/compose/manage/lock/${id}`, content);
  }
}

export async function publishLayout(id) {
  return request(`/api/compose/manage/releaseLayouts/${id}`, {
    method: 'PUT'
  });
}

export async function restoreLayout(id) {
  return request(`/api/compose/manage/restoreLayouts/${id}`, {
    method: 'PUT'
  });
}
